module.exports = __webpack_public_path__ + "static/img/115.186f29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/115.png
// module id = TQhc
// module chunks = 0